import dayjs from 'dayjs';

const url = 'https://www.jma.go.jp/bosai/forecast/data/forecast/200000.json';

async function getImagePath(code) {
  // asset_pathを取得するためrails側にweatherCodesに一致する画像パスを取得する
  const imageApiPath = `/asset_images?image_name=${code}`;
  fetch(imageApiPath, { method: 'GET' })
    .then((response) => response.json())
    .then((data) => {
      if (document.getElementById('weatherImg')) {
        document.getElementById('weatherImg').src = data.url; // サーバーから取得した画像のパス;
      }
      document.getElementById('headerWeatherImg').src = data.url;
    })
    .catch((error) => {
      console.error('Error fetching image path:', error);
    });
}

if (document.getElementById('headerDate')) {
  fetch(url)
    .then((response) => response.json())
    .then(async (weather) => {
      // 松本エリアを取得
      const matsumotoArea = weather[0].timeSeries[2].areas.find((area) => area.area.name === '松本');
      //長野県中部地方を取得
      const centralArea = weather[0].timeSeries[0].areas.find((area) => area.area.name === '中部');

      //データ取得
      const weatherCodes = centralArea.weatherCodes;

      const dateCode = weather[0].timeSeries[0].timeDefines[0];
      // yyyy/mm/dd hh:mm形式に整形
      const formattedDate = dayjs(dateCode).format('YYYY/MM/DD (ddd)'); // 曜日を追加

      // データ取得
      const temps = matsumotoArea.temps;

      const tempMin = temps[2]; // 最低気温
      const tempMax = temps[1]; // 最高気温

      await getImagePath(weatherCodes[0]);

      if (document.getElementById('date')) {
        document.getElementById('date').textContent = formattedDate;
        document.getElementById('tempMin').textContent = tempMin !== undefined ? `${tempMin}°C` : '--';
        document.getElementById('tempMax').textContent = tempMax !== undefined ? `${tempMax}°C` : '--';
      }

      document.getElementById('headerDate').textContent = formattedDate;
      document.getElementById('headerTempMin').textContent = tempMin !== undefined ? `${tempMin}°C` : '--';
      document.getElementById('headerTempMax').textContent = tempMax !== undefined ? `${tempMax}°C` : '--';
    })
    .catch((err) => console.error(err));
}
